import React from 'react';
import classes from './text.module.css';
import { Container } from "react-bootstrap";
import ListList from '../list/listList';

const TextFull = (props) => {
    return (
        <Container fluid="md">
             <div className={classes.textFull}>
                <h2>{props.text.title}</h2>
                <h3>{props.text.title2}</h3>
                <p>{props.text.body}<span>{props.text.body2}</span></p>
                <ul>
                    <ListList lists={props.lists}/>
                </ul>
                <div className={classes.textFull_bg}></div>
            </div>
        </Container>
    )
}

export default TextFull;